export const PESANPRIBADIS_GET = 'PESANPRIBADIS_GET';
export const PESANPRIBADI_ADD = 'PESANPRIBADI_ADD';
export const PESANPRIBADI_GET = 'PESANPRIBADI_GET';
export const PESANPRIBADI_EDIT = 'PESANPRIBADI_EDIT';
export const PESANPRIBADI_SEND = 'PESANPRIBADI_SEND';
export const PESANPRIBADI_REPORT = 'PESANPRIBADI_REPORT';
export const PESANPRIBADIPORTALUSERS_GET = 'PESANPRIBADIPORTALUSERS_GET';
export const PESANPRIBADI_UPLOADFILE = 'PESANPRIBADI_UPLOADFILE';
export const PESANPRIBADI_DELETE = 'PESANPRIBADI_DELETE';
export const PESANPRIBADI_IMPORT = 'PESANPRIBADI_IMPORT';